import { makeActionCreator } from '../App_Code/Utils';
import { ActAdh } from '../App_Data/ActionTypes';

export const avisEnvoye = makeActionCreator(ActAdh.ADH_AVIS_ENVOYE);
export const comprisAide = makeActionCreator(ActAdh.ADH_COMPRIS_AIDE);



// WEBPACK FOOTER //
// ./src/Actions/AdhActions.js